export default "__VITE_ASSET__CMLV8yKl__"